import { createFileRoute } from "@tanstack/react-router";

// Page content lives in the `$class` layout route so it stays mounted while the
// notities drawer child is open; this index only satisfies the exact-path match.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/reports/flow/$id/step/3/$class/",
)({
  component: () => null,
});
